import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/button";
import { useFormContext } from "@/form/common/hook";

export const SubmitButton = forwardRef<HTMLIonButtonElement, React.ComponentProps<typeof Button>>(
  function SubmitButton(props, ref) {
    const { t } = useTranslation();
    const form = useFormContext();

    return (
      <form.Subscribe
        selector={(state) => [state.canSubmit, state.isSubmitting] as const}
        children={([canSubmit, isSubmitting]) => (
          <Button
            ref={ref}
            type="submit"
            disabled={!canSubmit || isSubmitting}
            expand="block"
            {...props}
          >
            {isSubmitting ? t("common:loading") : (props.children ?? t("actions:save.action"))}
          </Button>
        )}
      />
    );
  },
);
